/* import __COLOCATED_TEMPLATE__ from './sprint-bracket-page-nensa-jr.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';

export default class SprintBracketPage extends Component 
{					
	get semifinalsResultsForDisplay()
	{
		let results = this.args.semifinalsResults;
		
		return results;
	}
	
	get finalsResultsForDisplay()
	{
		let results = this.args.finalsResults;
		
		let AResults = this.filterResultsForClassGroup(results,this.args.finalsClassGroups[0]);
		
		//populate display results with start list live from SF results until a real
		//start list has been created, then just return the real results
		if(AResults.length == 0)
		{
			return this.calculateFinalsAssignmentFromSemis();
		}
		else
		{
			return results;
		}
	}
	
	filterResultsForClassGroup(results,classGroupId)
	{
		if(results == null)
			return [];
		
		return results.filter(function(result)
		{
			return result.ClassGroupId == classGroupId;
		});
	}
	
	finishedOnlyFilter(result)
	{
		return result.totalTimeInMilliseconds != undefined;
	}
	
	sortFn(a,b)
	{
		//records with time above those without
		let aTime = a.totalTimeInMilliseconds;
		let bTime = b.totalTimeInMilliseconds;
	
		let aStatus = a.status;
		let bStatus = b.status;
	
		//always rank SUS status at bottom
		if(aStatus == "SUS" || aStatus == "RAL")
			return 1;
		if(bStatus == "SUS" || bStatus == "RAL")
			return -1
	
		if(aTime != null && bTime != null)
			return aTime>bTime ? 1 : aTime<bTime ? -1 : (a.id>b.id?1:-1);
		if(aTime != null)
			return -1;
		if(bTime != null)
			return 1;
		return (a.id>b.id?1:-1);		
	}
	
	calculateFinalsAssignmentFromSemis()
	{
		let AAssignments = [];
		
		let semifinalsResults = this.args.semifinalsResults;
		
		//get results for each classgroup
		let S1Results = this.filterResultsForClassGroup(semifinalsResults,this.args.semifinalsClassGroups[0]);
		let S2Results = this.filterResultsForClassGroup(semifinalsResults,this.args.semifinalsClassGroups[1]);
		let S3Results = this.filterResultsForClassGroup(semifinalsResults,this.args.semifinalsClassGroups[2]);
		
		let S1ResultsFiltered = S1Results.filter(this.finishedOnlyFilter);
		let S2ResultsFiltered = S2Results.filter(this.finishedOnlyFilter);
		let S3ResultsFiltered = S3Results.filter(this.finishedOnlyFilter);
		
		S1ResultsFiltered.sort(this.sortFn);
		S2ResultsFiltered.sort(this.sortFn);
		S3ResultsFiltered.sort(this.sortFn);
		
		if(S1ResultsFiltered.length > 0)
			AAssignments.push(Object.assign({},S1ResultsFiltered[0]));
		if(S2ResultsFiltered.length > 0)
			AAssignments.push(Object.assign({},S2ResultsFiltered[0]));
		if(S3ResultsFiltered.length > 0)
			AAssignments.push(Object.assign({},S3ResultsFiltered[0]));
		
		if(S1ResultsFiltered.length > 1)
			AAssignments.push(Object.assign({},S1ResultsFiltered[1]));
		if(S2ResultsFiltered.length > 1)
			AAssignments.push(Object.assign({},S2ResultsFiltered[1]));
		if(S3ResultsFiltered.length > 1)
			AAssignments.push(Object.assign({},S3ResultsFiltered[1]));
		
		
		let tempIds=0;
		for(let assignment of AAssignments)
		{
			assignment.ClassGroupId=this.args.finalsClassGroups[0];
			assignment.place = null;
			assignment.totalTimeInMilliseconds = null;
			assignment.id=tempIds;
			tempIds++;
		}
		
		return AAssignments;
	}
}
